import { render, staticRenderFns } from "./rankGolomt.vue?vue&type=template&id=8b6f12a4"
import script from "./rankGolomt.vue?vue&type=script&lang=js"
export * from "./rankGolomt.vue?vue&type=script&lang=js"
import style0 from "./rankGolomt.vue?vue&type=style&index=0&id=8b6f12a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports